module.exports = __webpack_public_path__ + "ee6ac766/img/mini-logo.18817ee5.svg";